const dispatchRangeChange = (sliderElement, value) => {
  const sliderId = sliderElement.id || sliderElement.dataset.id || null;
  sliderElement.dispatchEvent(
      new CustomEvent("range:change", {
        detail: { value, id: sliderId },
        bubbles: true,
      })
  );
};

const singleRangeSliderTooltip = () => {
  const singleRange = document.getElementsByClassName(
      "single-range-tooltip"
  )[0];
  if (singleRange) {
    const slider = singleRange.querySelector("#single-range-tooltip");
    const max = +slider.dataset.max;
    const min = +slider.dataset.min;
    const unit = slider.dataset?.unit || "";
    const step = +slider.dataset.step;
    const inputHidden = singleRange.querySelector(
        ".single-range-hidden-input"
    );
    const startValue = +inputHidden.value;

    // how many percentages
    const borderLimit = 8;
    const borderDiff = 40 / borderLimit;
    let lastEmittedValue = Math.round(startValue);

    noUiSlider.create(slider, {
      start: [startValue],
      connect: 'lower',
      tooltips: true,
      margin: 10,
      step: step,
      range: {
        min: min,
        max: max,
      },
    });

    const tooltip = slider.querySelector(".noUi-tooltip");
    const circle = slider.querySelector(".noUi-origin");

    function returnTransform(element) {
      return element
          .replace(/[^0-9][^\d.]/g, "")
          .replace(")", "")
          .split(" ")
          .map((str) => {
            return Number(str);
          });
    }

    slider.noUiSlider.on("update", function (values) {
      let translate = returnTransform(circle.style.transform)[0];
      const roundedValue = Math.round(values);

      inputHidden.value = roundedValue;

      if (roundedValue !== lastEmittedValue) {
        lastEmittedValue = roundedValue;
        dispatchRangeChange(slider, roundedValue);
      }

      if (translate <= -100 + borderLimit) {
        tooltip.style.transform = `translate(${
            -50 + Math.abs(translate + 100 - borderLimit) * borderDiff
        }%,100%)`;
      } else if (translate >= -borderLimit) {
        tooltip.style.transform = `translate(${
            -50 - Math.abs(translate + borderLimit) * borderDiff
        }%,100%)`;
      } else {
        tooltip.style.transform = "translate(-50%,100%)";
      }

      tooltip.textContent =
          unit + roundedValue.toLocaleString("en-GB");
    });
  }
};
singleRangeSliderTooltip();
